export default __webpack_public_path__ + "static/media/gallery_09.5186a015.jpg";